<template>
  <div class="PacientesListado">
    <v-card
      outlined
      :disabled="cargando"
      :loading="cargando"
    >
      <v-card-title>
        Pacientes
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Buscar"
          hide-details
        />
        <ButtonAdd to="/paciente" />
      </v-card-title>
      <v-data-table
        class="upper"
        :headers="headers"
        :items="pacientes"
        :search="search"
        :loading="cargando"
        loading-text="Cargando..."
        @click="value=$event"
      >
        <template v-slot:item.actions="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
              >
                <v-icon v-text="'more_vert'" />
              </v-btn>
            </template>
            <v-list dark>
              <v-list-item :to="'/paciente/'+item.id">
                <v-list-item-title v-text="'Editar'" />
              </v-list-item>
              <v-list-item :to="'/paciente/historiaclinica/'+item.id+'/citas'">
                <v-list-item-title v-text="'Historia clínica'" />
              </v-list-item>
              <v-list-item :to="'/consulta/'+item.id">
                <v-list-item-title v-text="'Consulta dental'" />
              </v-list-item>
              <v-list-item @click="idPac=item.id">
                <v-list-item-title v-text="'Carrito de compra'" />
              </v-list-item>
              <v-list-item :to="'/encuesta/'+item.id">
                <v-list-item-title v-text="'Encuesta de satisfacción'" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
    <carrito-dialog
      v-model="idPac"
      @msg="$emit('msg',$event)"
      @httpError="$emit('httpError',$event)"
    />
  </div>
</template>
<script>
import standard from "@/mixins/standard.js";
import CarritoDialog from "@/components/carrito/CarritoDialog.vue";
export default {
  name: "PacientesListado",
  mixins: [standard],
  components: { CarritoDialog },
  data() {
    return {
      pacientes: [],
      headers: [
        { text: "Nombre", value: "nombre" },
        { text: "Fecha nac.", value: "fecha_nac_pac" },
        { text: "Desde", value: "created_pac" },
        { text: "", value: "actions", align: "end" },
      ],
      idPac: null,
      value: {},
    };
  },
  methods: {},
  created() {
    this._getAll("pacientes");
  },
};
</script>